
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    // Initialize with current window width on mount
    return typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  })

  React.useEffect(() => {
    // Skip effect during SSR
    if (typeof window === 'undefined') return
    
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    // Add event listener for resize
    window.addEventListener('resize', checkIfMobile)
    
    // Initial check
    checkIfMobile()
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])

  return isMobile
}
